import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import Button from '@material-ui/core/Button'

const useStyle = makeStyles((theme) => ({
  text: {
    color: '#3A3A3A !important',
  },
  button: {
    margin: theme.spacing(1),
    color: '#3A3A3A',
    width: '255px',
  },
}))

export default (props) => {
  const classes = useStyle(props)

  function handleClickOpen() {
    window.open('https://ifyoucanllc.atlassian.net/l/c/KojKxd1a', '_blank')
  }

  return (
    <div className="flex flex-col justify-center">
      <Button
        variant="outlined"
        className={classes.button}
        color="inherit"
        onClick={handleClickOpen}
      >
        <div className="md:flex flex-col ltr:mr-12 rtl:ml-12 items-end">
          <Typography
            component="span"
            className={clsx(classes.text, 'normal-case font-600 flex')}
          >
            MessageSpring Changelog
          </Typography>
          <Typography
            className={clsx(classes.text, 'text-11 capitalize text-right')}
          >
            Confluence Page
          </Typography>
        </div>
      </Button>
    </div>
  )
}
